import Select from "react-select";
import '../../styles/DropDownComponent.css';

const DropDownComponent = ({ options = [], onChange, value, placeholder, isDisabled = false, noOptionsMessage }) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption?.value || "");
  }
  return (
    <div className="assignment-column-row">
      <label className="assignment-column-label">Filter by</label>
      <Select
        options={options}
        isClearable
        value={options.find((opt) => String(opt.value) === String(value)) || null}
        onChange={handleChange}
        placeholder={placeholder}
        isSearchable
        isDisabled={isDisabled}
        {...(noOptionsMessage ? { noOptionsMessage: () => noOptionsMessage } : {})}
        className="assignment-column-filter"
        classNamePrefix="dropdown"
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  )

}
export default DropDownComponent;